import LocationSetup from './LocationSetup';

export default LocationSetup;
